import { motion, type Variants } from 'motion/react'
import { type SVGProps } from 'react'
import { cn } from '#app/utils/misc.js'

const draw: Variants = {
	hidden: { pathLength: 0, opacity: 0 },
	visible: (i: number) => {
		const delay = i * 0.5
		return {
			pathLength: 1,
			opacity: 1,
			transition: {
				pathLength: { delay, type: 'spring', duration: 1.5, bounce: 0 },
				opacity: { delay, duration: 0.01 },
			},
		}
	},
}

export function AnimatedLogo(props: any) {
	return (
		<motion.svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 1920 1920"
			{...props}
			className={cn('fill-current', props.className)}
			initial="hidden"
			animate="visible"
		>
			<motion.path
				variants={draw}
				custom={2}
				stroke="currentColor"
				fill="transparent"
				strokeWidth={8}
				strokeLinecap="round"
				d="M1353.2,1472.45c0,3.89-.06,7.75-.18,11.6-7.18,226.99-224.72,383.44-476.8,383.44-224.84,0-399.24-86.16-487.49-149.19l-14.71-268.78v-.18l21.01-2.11c71.44,201.72,201.72,388.74,510.61,388.74,191.21,0,346.7-126.08,346.7-294.17,0-214.33-241.64-313.1-428.65-386.64-283.67-111.37-413.95-214.33-413.95-413.95,0-140.42,72.14-250.61,192.84-315.47-.05,2.35-.07,4.71-.07,7.08,0,11.88.46,23.42,1.39,34.64-59.33,48.57-97.51,120.83-97.51,217.02,0,205.93,220.64,292.08,413.95,371.92,236.04,97.2,412.17,185.03,431.16,380.16,1.13,11.57,1.7,23.53,1.7,35.89Z"
			/>
			<motion.path
				stroke="currentColor"
				custom={1}
				fill="transparent"
				strokeWidth={8}
				strokeLinecap="round"
				variants={draw}
				d="M1545.98,1164.07c0,137.82-77.03,250.69-192.95,319.99.12-3.85.18-7.71.18-11.6,0-12.36-.57-24.32-1.7-35.89,58.04-51.97,93.61-122.76,93.61-203.16,0-214.33-241.64-313.09-428.65-386.64-266.78-104.73-397.9-202.03-412.56-379.3-.93-11.22-1.39-22.76-1.39-34.64,0-2.37.02-4.73.07-7.08,3.94-227.1,198.28-373.24,481.12-373.24,231.13,0,363.51,71.44,416.05,105.06l8.4,212.22-16.81,4.2c-69.34-144.98-182.81-289.97-462.27-289.97-172.31,0-329.91,96.66-329.91,292.08,0,205.92,220.64,292.07,413.95,371.92,250.05,102.96,432.86,195.41,432.86,416.05Z"
			/>
		</motion.svg>
	)
}

export default function Logo(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 1920 1920"
			{...props}
			className={cn('fill-current', props.className)}
		>
			<g id="Capa_1">
				<path d="M1353.2,1472.45c0,3.89-.06,7.75-.18,11.6-7.18,226.99-224.72,383.44-476.8,383.44-224.84,0-399.24-86.16-487.49-149.19l-14.71-268.78v-.18l21.01-2.11c71.44,201.72,201.72,388.74,510.61,388.74,191.21,0,346.7-126.08,346.7-294.17,0-214.33-241.64-313.1-428.65-386.64-283.67-111.37-413.95-214.33-413.95-413.95,0-140.42,72.14-250.61,192.84-315.47-.05,2.35-.07,4.71-.07,7.08,0,11.88.46,23.42,1.39,34.64-59.33,48.57-97.51,120.83-97.51,217.02,0,205.93,220.64,292.08,413.95,371.92,236.04,97.2,412.17,185.03,431.16,380.16,1.13,11.57,1.7,23.53,1.7,35.89Z" />
			</g>
			<g id="Capa_2">
				<path d="M1545.98,1164.07c0,137.82-77.03,250.69-192.95,319.99.12-3.85.18-7.71.18-11.6,0-12.36-.57-24.32-1.7-35.89,58.04-51.97,93.61-122.76,93.61-203.16,0-214.33-241.64-313.09-428.65-386.64-266.78-104.73-397.9-202.03-412.56-379.3-.93-11.22-1.39-22.76-1.39-34.64,0-2.37.02-4.73.07-7.08,3.94-227.1,198.28-373.24,481.12-373.24,231.13,0,363.51,71.44,416.05,105.06l8.4,212.22-16.81,4.2c-69.34-144.98-182.81-289.97-462.27-289.97-172.31,0-329.91,96.66-329.91,292.08,0,205.92,220.64,292.07,413.95,371.92,250.05,102.96,432.86,195.41,432.86,416.05Z" />
			</g>
		</svg>
	)
}
